import styled, { rem } from 'theme';

export const ErrorMessage = styled('div')`
  color: var(--sys-color-error);
  width: 100%;
  display: flex;
  align-items: center;
  fill: var(--sys-color-error);
  padding-top: ${rem(4)};

  svg {
    margin-right: ${rem(4)};
    width: ${rem(24)};
    height: ${rem(24)};
  }

  a {
    color: var(--sys-color-error);
    text-decoration: underline;
  }
`;
